import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Login/components/layout";
import SignUpPage from "../../components/signUp";
import GuestRoute from "../../components/GuestRoute";

const SignUpContainer = () => (
  <GuestRoute>
    <main>
      <Helmet title="Sign Up" />
      <Layout>
        <SignUpPage />
      </Layout>
    </main>
  </GuestRoute>
);

export default SignUpContainer;
